"use strict";
Object.defineProperty(exports, "__esModule", { value: true });
exports.iconCardStylesHover = exports.selectedStyles = exports.IconCard = void 0;
const jsx_runtime_1 = require("@emotion/react/jsx-runtime");
const react_1 = require("react");
const react_aria_1 = require("react-aria");
const react_stately_1 = require("react-stately");
const components_1 = require("../components");
const Css_1 = require("../Css");
const useGetRef_1 = require("../hooks/useGetRef");
const utils_1 = require("../utils");
const defaultTestId_1 = require("../utils/defaultTestId");
function IconCard(props) {
    const { selected: isSelected = false, disabled: isDisabled = false, icon, cardRef, label, tooltip, ...otherProps } = props;
    const ref = (0, useGetRef_1.useGetRef)(cardRef);
    const ariaProps = { isSelected, isDisabled, ...otherProps };
    const checkboxProps = { ...ariaProps, "aria-label": label };
    const { hoverProps, isHovered } = (0, react_aria_1.useHover)({ isDisabled });
    const toggleState = (0, react_stately_1.useToggleState)(ariaProps);
    const { inputProps } = (0, react_aria_1.useCheckbox)(checkboxProps, toggleState, ref);
    const styles = (0, react_1.useMemo)(() => ({
        ...baseStyles,
        ...(isHovered && exports.iconCardStylesHover),
        ...(isSelected && exports.selectedStyles),
        ...(isDisabled && disabledStyles),
    }), [isDisabled, isHovered, isSelected]);
    const tid = (0, utils_1.useTestIds)(props, (0, defaultTestId_1.defaultTestId)(label));
    return (0, components_1.maybeTooltip)({
        title: (0, components_1.resolveTooltip)(isDisabled, tooltip),
        placement: "top",
        children: ((0, jsx_runtime_1.jsxs)("button", { css: styles, ...hoverProps, onClick: toggleState.toggle, disabled: isDisabled, ...tid, children: [(0, jsx_runtime_1.jsx)(react_aria_1.VisuallyHidden, { children: (0, jsx_runtime_1.jsx)("input", { ref: ref, ...inputProps, ...tid.value }) }), (0, jsx_runtime_1.jsx)(components_1.Icon, { icon: icon, inc: 4, color: isDisabled ? Css_1.Palette.Gray300 : Css_1.Palette.Gray900 }), (0, jsx_runtime_1.jsx)("span", { css: Css_1.Css.xsMd.if(isDisabled).gray300.$, children: label })] })),
    });
}
exports.IconCard = IconCard;
const baseStyles = Css_1.Css.df.fdc.aic.jcc.wPx(130).hPx(114).ba.br8.bcGray300.bgWhite.gap("12px").p2.tac.$;
exports.selectedStyles = Css_1.Css.bw2.bcBlue500.bgBlue50.$;
const disabledStyles = Css_1.Css.bcGray200.bgGray50.$;
exports.iconCardStylesHover = Css_1.Css.bgGray100.$;
